import { resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 0,
  class: "m-panel__body"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconComponent = _resolveComponent("IconComponent")!
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{ '-has-no-border': _ctx.state.hasNoBorder }, "m-panel"])
  }, [
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args))),
      class: _normalizeClass([{
                '-can-toggle': _ctx.state.isClosable,
                '-is-open': _ctx.state.isContentShown,
                '-is-empty': _ctx.state.hasNoHeader,
            }, "m-panel__head"]),
      onKeydown: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleKeyPress($event))),
      "data-js": "panel-header",
      tabindex: "0"
    }, [
      (!_ctx.state.hasNoHeader)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_ctx.isTitleTranslation)
              ? _withDirectives((_openBlock(), _createElementBlock("h2", _hoisted_1, null, 512)), [
                  [_directive_translate, _ctx.state.title]
                ])
              : (_openBlock(), _createElementBlock("h2", _hoisted_2, _toDisplayString(_ctx.state.title), 1))
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.state.isClosable && !_ctx.state.hasNoHeader)
        ? (_openBlock(), _createBlock(_component_IconComponent, {
            key: 1,
            "icon-id": _ctx.iconName.Arrow
          }, null, 8, ["icon-id"]))
        : _createCommentVNode("", true)
    ], 34),
    (_ctx.state.isContentShown)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "default")
        ]))
      : _createCommentVNode("", true)
  ], 2))
}